const u = (id, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: '/listings/hero-render.webp',
  interior: u('photo-1610177534644-34d881503b83', 2000),
  services: {
    custom: u('photo-1773427457869-6fbded8b89b9'),
    renovations: u('photo-1662505899914-1000c566477b'),
    remodeling: '/listings/kitchen-white-oak.webp',
  },
};

export const NAV_LINKS = [
  { id: 'services', label: 'Services' },
  { id: 'showcase', label: 'Showcase' },
  { id: 'properties', label: 'Properties' },
  { id: 'contact', label: 'Contact' },
];

export const MARQUEE_ITEMS = [
  'Bespoke Custom Homes',
  'Full-Scale Renovations',
  'Architectural Remodeling',
  'Hand-Finished Detail',
  'Turnkey Delivery',
  'Stone · Timber · Glass',
];

export const SERVICES = [
  {
    id: 'custom-homes',
    type: 'New Custom Home',
    title: 'New Custom Homes',
    accent: 'Custom',
    image: IMAGES.services.custom,
    desc: 'Ground-up residences designed and built around the way you live — one crew, one standard, from foundation to final hardware.',
    points: ['Design–build partnership', 'White-glove project management', 'Turnkey, move-in-ready delivery'],
  },
  {
    id: 'renovations',
    type: 'Full-Scale Renovation',
    title: 'Full-Scale Renovations',
    accent: 'Renovations',
    image: IMAGES.services.renovations,
    desc: 'Whole-home transformations that restructure, re-plan and completely renew the house you already own.',
    points: ['Structural reconfiguration', 'Whole-home transformations', 'Heritage and estate restorations'],
  },
  {
    id: 'remodeling',
    type: 'Remodeling',
    title: 'Remodeling',
    accent: 'Remodeling',
    image: IMAGES.services.remodeling,
    desc: 'Kitchens, baths, additions and suites — remodeled with the same millwork and finish quality as our new builds.',
    points: ['Kitchens and baths', 'Custom millwork and finishes', 'Additions and in-law suites'],
  },
];

export const PROJECT_FILTERS = [
  { key: 'all', label: 'All Work' },
  { key: 'new', label: 'New Estates' },
  { key: 'transformation', label: 'Transformations' },
  { key: 'detail', label: 'Detail Work' },
];

export const PROJECTS = [
  {
    id: 'bungalow-build',
    title: 'Custom Bungalow Full Renovation',
    category: 'transformation',
    specs: 'Full-Scale Renovation · Calgary',
    year: '',
    image: '/listings/showcase-bungalow.webp',
  },
  {
    id: 'white-brick-bungalow',
    title: 'White Brick Bungalow Renovation',
    category: 'transformation',
    specs: 'Full-Scale Renovation · Calgary',
    year: '',
    image: '/listings/showcase-white-brick.webp',
  },
  {
    id: 'duplex-3404',
    title: 'Side-by-Side Duplex — 3404 & 3406',
    category: 'new',
    specs: 'New Duplex Construction · Two Storey',
    year: '',
    image: '/listings/duplex-3404.webp',
  },
  {
    id: 'white-oak-kitchen',
    title: 'White Oak Kitchen & Island',
    category: 'detail',
    specs: 'Custom Kitchen · Slat Island Millwork',
    year: '',
    image: '/listings/kitchen-white-oak.webp',
  },
  {
    id: 'vaulted-great-room',
    title: 'Vaulted Great Room Renewal',
    category: 'transformation',
    specs: 'Living Area Renovation · Fireplace Feature',
    year: '',
    image: '/listings/living-vaulted.webp',
  },
  {
    id: 'black-island-kitchen',
    title: 'Black Island Family Kitchen',
    category: 'transformation',
    specs: 'Complete Kitchen Remodel',
    year: '',
    image: '/listings/kitchen-black-island.webp',
  },
  {
    id: 'galley-kitchen',
    title: 'Black & White Galley Kitchen',
    category: 'detail',
    specs: 'Kitchen Remodel · Brass Fixtures',
    year: '',
    image: '/listings/kitchen-galley.webp',
  },
  {
    id: 'marble-bath',
    title: 'Marble Primary Bath Retreat',
    category: 'detail',
    specs: 'Black Marble · Brass Fixtures',
    year: '',
    image: '/listings/bath-marble.webp',
  },
];

export const PROPERTIES = [
  {
    id: '69-holland',
    title: '69 Holland St NW',
    price: 'Price on Request',
    status: '2026 Build · Ready',
    stats: ['5 Beds', '2,000 sq ft', 'Legal Suite'],
    location: 'Holland St NW, Calgary',
    image: '/listings/69-holland-elevation.png',
    fit: 'contain',
  },
  {
    id: '67-holland',
    title: '67 Holland St NW',
    price: 'Price on Request',
    status: '2026 Build · Ready',
    stats: ['5 Beds', '2,000 sq ft', 'Legal Suite'],
    location: 'Holland St NW, Calgary',
    image: '/listings/67-holland-elevation.png',
    fit: 'contain',
  },
  {
    id: '300-edgehill',
    title: '300 Edgehill Dr NW',
    price: '$784,000',
    status: 'Move-In Ready',
    stats: ['6 Beds', 'Basement Suite', 'Fully Renovated'],
    location: 'Edgemont, Calgary',
    image: '/listings/300-edgehill.webp',
  },
];

export const WHY_INVICTO = [
  {
    id: 'craftsmanship',
    title: 'Craftsmanship',
    desc: 'One standard of finish across everything we build — no trim-package upgrades, no shortcuts hidden behind drywall.',
  },
  {
    id: 'communication',
    title: 'Clear Communication',
    desc: 'Regular site updates and a single point of contact, so you always know what happened this week and what happens next.',
  },
  {
    id: 'aftercare',
    title: 'Aftercare',
    desc: 'Our relationship continues after handover — we come back, we fix, we finish what we started.',
  },
  {
    id: 'one-team',
    title: 'One Accountable Team',
    desc: 'Design and construction under one roof. One team answers for the schedule, the budget and the finish.',
  },
];

export const FAQS = [
  {
    q: 'How long does building a custom home take?',
    a: 'Most custom homes take between ten and eighteen months from breaking ground to handover, depending on size, complexity and permitting. Before we start, you get a realistic schedule — and regular updates as it unfolds.',
  },
  {
    q: 'What does a custom home or renovation cost?',
    a: "Every project is priced on its own scope, so we don't publish one-size-fits-all numbers. Share your outline through the form below and we'll come back with a detailed, itemized estimate — and honest guidance on where to spend and where to save.",
  },
  {
    q: 'Do you build on my lot, or can I buy one of yours?',
    a: "Both. We build on land you already own, and we also offer ready Invicto properties — see the Ready Properties section above, or ask us what's currently available.",
  },
  {
    q: 'Can I make design changes once construction starts?',
    a: 'Yes. Changes are handled through a simple written change order, so you always see the cost and schedule impact before anything is approved. No surprises at the end.',
  },
  {
    q: 'Do you handle permits, engineering and inspections?',
    a: 'Yes — permitting, engineering and inspection coordination are part of every Invicto project. You deal with one team; we deal with the paperwork.',
  },
  {
    q: 'What happens after we move in?',
    a: "We walk the home with you before handover and come back for a service visit after you've settled in. If something isn't right, one call to us is all it takes.",
  },
];

export const PROJECT_TYPES = [
  'New Custom Home',
  'Full-Scale Renovation',
  'Remodeling',
  'Ready Property Inquiry',
  'Other',
];

export const BUDGET_RANGES = [
  'Under $250k',
  '$250k – $500k',
  '$500k – $1M',
  '$1M – $2.5M',
  '$2.5M+',
  'Not sure yet',
];

export const CONTACT = {
  email: 'info@invictohomes.com',
};

export const SOCIAL = [
  { id: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/invictohomes' },
  { id: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/invictohomesinc' },
  { id: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/@invictohomes' },
];
